import { ActionTypes } from "../constants/action-types";
const initialState = {
};

export function navigationReducer(state = initialState, { type, payload }) {
    switch (type) {
        case ActionTypes.SET_NAVIGATION_PARAMETER:
            return { ...state, navigationData: payload };
        default:
            return state;
    }
}